import React from "react";

import { Overlay } from "../Overlay/Overlay";
import { Loader } from "../Loader/Loader";

export const LoadingOverlay = ({
    className,
    color
}) => (
    <Overlay
        className={className}
        color={color}
    >
        <Loader/>
    </Overlay>
);
